<div class="row">
    <div class="col-12">
        <div class="row no-gutters">
            <div class="myform form" style="margin-left: 40%;width: 30%;">
                <p style="color: red;"></p>
                <form [formGroup]="registrationForm" (ngSubmit)="onSubmit()">
                    <h4 class="font-weight-bold font-size-18">Register</h4>
                    <div class="form-group">
                        <label>full_name</label>
                        <input type="text" placeholder="full_name" formControlName="full_name"
                            class="form-control font-size-12"
                            [ngClass]="{ 'is-invalid': submitted && f.full_name.errors }" />
                        <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
                            <div *ngIf="f.full_name.errors.required" class="font-size-12">full_name is required
                            </div>
                            <div *ngIf="f.full_name.errors.minlength" class="font-size-12">full_name must be at
                                least
                                6 characters</div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label>Email</label>
                        <input type="text" placeholder="Email" formControlName="email" class="form-control font-size-12"
                            [ngClass]="{ 'is-invalid': submitted && f.email.errors }" />
                        <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
                            <div *ngIf="f.email.errors.required" class="font-size-12">Email is required</div>
                            <div *ngIf="f.email.errors.email" class="font-size-12">Email must be a valid email
                                address</div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label>password</label>
                        <input type="password" placeholder="Password" formControlName="password"
                            class="form-control font-size-12"
                            [ngClass]="{ 'is-invalid': submitted && f.password.errors }" />
                        <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
                            <div *ngIf="f.password.errors.required" class="font-size-12">Password is required
                            </div>
                            <div *ngIf="f.password.errors.minlength" class="font-size-12">Password must be at
                                least
                                6 characters</div>
                        </div>
                    </div>
                    <div class="form-group" *ngIf="!registrationForm.get('is_manager').value">
                        <label>company_name</label>
                        <input type="text" placeholder="company_name" formControlName="company_name"
                            class="form-control font-size-12" id="companyname"
                            [ngClass]="{ 'is-invalid': submitted && f.company_name.errors }" />
                        <div *ngIf="submitted && f.company_name.errors" class="invalid-feedback">
                            <div *ngIf="f.company_name.errors.required" class="font-size-12">company_name is
                                required</div>
                            <div *ngIf="f.company_name.errors.minlength" class="font-size-12">company_name must
                                be
                                at least
                                6 characters</div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label>is_manager</label>
                        <input type="checkbox" placeholder="is_manager" formControlName="is_manager"
                            class="form-control font-size-12" id="is_manager" ng-model="is_manager"
                            [ngClass]="{ 'is-invalid': submitted && f.is_manager.errors }"
                            style="margin-left: -183px" />
                        <div *ngIf="submitted && f.is_manager.errors" class="invalid-feedback">
                            <div *ngIf="f.is_manager.errors.required" class="font-size-12">is_manager is
                                required
                            </div>
                            <div *ngIf="f.is_manager.errors.minlength" class="font-size-12">is_manager must be
                                at
                                least
                                6 characters</div>
                        </div>
                    </div>
                    <div class="form-group" *ngIf="registrationForm.get('is_manager').value">
                        <label>username</label>
                        <input type="text" placeholder="username" formControlName="username" id="username"
                            class="form-control font-size-12" />
                        <div class="error"
                            *ngIf="registrationForm.get('username').invalid && registrationForm.get('username').touched">
                            Please enter a valid value.
                        </div>
                        <!-- <div *ngIf="submitted && f.username.errors" class="invalid-feedback">
                            <div *ngIf="f.username.errors.required" class="font-size-12">username is required
                            </div>
                            <div *ngIf="f.username.errors.minlength" class="font-size-12">username must be at
                                least
                                6 characters</div>
                        </div> -->
                    </div>
                    <div class="text-center ">
                        <button type="submit" class=" btn btn-block btn btn-primary tx-tfm font-size-14">Sign
                            in</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>